import { useCallback, useEffect } from 'react'
import { observer } from 'mobx-react'

import { ScrollToTop } from 'Components/ScrollToTop/ScrollToTop'

import { useStore } from 'Stores/index'

import { useActiveUser } from 'Hooks'

import { getOrderEmployee_employee_office_address } from 'Constants/graphql/queries/feature/__generated__/getOrderEmployee'
import { getOrderOrganisation_organisation_offices_offices_address } from 'Constants/graphql/queries/feature/__generated__/getOrderOrganisation'

import { OrderStepEnum } from 'Portal/src/stores/orderStore/orderStore.types'

import { OrderAddressForm } from '../../OrderAddressForm/OrderAddressForm'
import { AddressStepProps } from '../Steps.types'

export const AddressStep = observer((props: AddressStepProps) => {
  const { activeEmployeeId, handleNextStep, handlePreviousStep } = props
  const { orderStore } = useStore()
  const { activeEmployee } = useActiveUser()
  const {
    clearChosenDeviceLimitationRules,
    chosenShippingAddress,
    chosenShippingAddressType,
    setChosenShippingAddress,
    setChosenShippingAddressLabel,
    setChosenShippingAddressType,
    officeAddress,
    shouldSkipAccessories,
    fetchEmployeeContact,
    employeeContact,
    setCurrentStep,
  } = orderStore

  const handleNextAction = useCallback(() => {
    if (handleNextStep) {
      handleNextStep()
    }
  }, [handleNextStep])

  const handlePreviousAction = useCallback(() => {
    if (handlePreviousStep) {
      if (shouldSkipAccessories) {
        clearChosenDeviceLimitationRules()
      }

      handlePreviousStep()
    }
  }, [
    clearChosenDeviceLimitationRules,
    handlePreviousStep,
    shouldSkipAccessories,
  ])

  useEffect(() => {
    setCurrentStep(OrderStepEnum.address)
  }, [setCurrentStep])

  const handleSubmitAddressForm = useCallback(
    (
      address:
        | getOrderEmployee_employee_office_address
        | getOrderOrganisation_organisation_offices_offices_address
        | null,
    ) => {
      if (!address) {
        return
      }

      setChosenShippingAddress({
        city: address.city,
        country: address.country,
        id: '',
        name: address.name,
        nameAddition: address.nameAddition,
        street: address.street,
        streetAddition: address.streetAddition,
        zipcode: address.zipcode,
      })

      handleNextAction()
    },
    [handleNextAction, setChosenShippingAddress],
  )

  useEffect(() => {
    if (!activeEmployee && activeEmployeeId) {
      fetchEmployeeContact(activeEmployeeId)
    }
  }, [activeEmployeeId, activeEmployee, fetchEmployeeContact])

  return (
    <>
      <ScrollToTop />

      <OrderAddressForm
        chosenShippingAddress={chosenShippingAddress}
        chosenShippingAddressType={chosenShippingAddressType}
        employeeContact={employeeContact}
        officeAddress={officeAddress}
        onBackButtonClick={handlePreviousAction}
        onSetChosenShippingAddressLabel={setChosenShippingAddressLabel}
        onSetChosenShippingAddressType={setChosenShippingAddressType}
        onSubmitButtonClick={handleSubmitAddressForm}
      />
    </>
  )
})
